module.exports = __webpack_public_path__ + "img/drag_handle.92c9e938.svg";